import { Icon } from '@chakra-ui/react';
import { IconName } from '@ailibs/feather-react-ts';
import { PiMegaphone, PiPiggyBank, PiHandTap } from 'react-icons/pi';
import { t } from '@/i18n';
// import { ReactComponent as BillingManagement3 } from '@/assets/icons/BillingManagement3.svg';

export interface MenuItemProps {
  id: number;
  novidade?: any[];
  label: string;
  icon: IconName | JSX.Element;
  link?: string;
  badge?: string;
  badgecolor?: string;
  subItems?: any;
  isHeader?: boolean;
}

const menuItems: Array<MenuItemProps> = [
  {
    id: 1,
    label: t('components.vertical_layout.menu_item_home'),
    icon: 'home',
    link: '/',
  },

  { id: 2, label: t('components.vertical_layout.menu_item_users'), icon: 'users', link: '/account' },
  // { id: 3, label: 'Assinantes', icon: <UserStar width={24} height={24} />, link: '/subscribers' },
  // {
  //   id: 4,
  //   label: 'Planos de Acesso',
  //   icon: 'flag',
  //   link: '/access-plans',
  // },
  { id: 5, label: t('components.vertical_layout.menu_item_application'), icon: 'smartphone', link: '/application' },
  // {
  //   id: 6,
  //   label: 'Clube de Fidelidade',
  //   icon: 'gift',
  //   link: '/loyalty-club',
  //   subItems: [
  //     {
  //       id: 61,
  //       label: 'Campanhas e Regras',
  //       parentId: 6,
  //       link: '/loyalty-club/campaigns-and-rules',
  //     },
  //     {
  //       id: 62,
  //       label: 'Extrato de Pontos',
  //       parentId: 6,
  //       link: '/loyalty-club/points-extract',
  //     },
  //   ],
  // },
  // { id: 7, label: 'Campanhas de Arrecadação', icon: <Icon as={PiPiggyBank} />, link: '/fundraising-campaign' },
  // { id: 7, label: 'Áreas Interativas', icon: <Icon as={PiHandTap} />, link: '/interactive-area' },
  // { id: 7, label: 'Campanhas de Arrecadação', icon: <Icon as={PiPiggyBank} />, link: '/fundraising-campaign' },
  // { id: 8, label: 'Financeiro', icon: <Icon as={BillingManagement3} />, link: '/financial' },
  { id: 9, label: t('components.vertical_layout.menu_item_partners'), icon: 'star', link: '/partners' },
  { id: 10, label: t('components.vertical_layout.menu_item_access_control'), icon: 'toggle-right', link: '/access-control' },
  {
    id: 11,
    label: t('components.vertical_layout.menu_item_communication_central'),
    icon: <Icon as={PiMegaphone} transform='scaleX(-1)' />,
    link: '/communication-central',
  },
];

export { menuItems };
